/* WINROVA premium product totals — read-only presentation; checkout owns discounts. */
(() => {
  "use strict";
  const money = cents => {
    try { return new Intl.NumberFormat("he-IL",{style:"currency",currency:"ILS",minimumFractionDigits:0,maximumFractionDigits:2}).format(cents/100); }
    catch(e) { return "₪"+(cents/100).toFixed(2); }
  };
  document.querySelectorAll("[data-product-root]").forEach(root => {
    const find = s => root.querySelector(s);
    const all = s => [...root.querySelectorAll(s)];
    const qty = find('input[name="quantity"]');
    const id = find("[data-variant-id]");
    if(!qty || !id) return;
    let variants;
    try { variants=JSON.parse(find("[data-product-variants]")?.textContent||"[]"); }
    catch(e) { variants=[]; }
    const getVariant = () => variants.find(v=>String(v.id)===String(id.value));
    const total = find("[data-order-total]");
    const before = find("[data-order-before]");
    const saving = find("[data-order-saving]");
    const count = find("[data-quantity-count]");
    const label = find("[data-discount-label]");
    const render = () => {
      const variant=getVariant();
      if(!variant) return;
      const raw=Number(qty.value);
      const n=Math.max(1,Math.min(99,Number.isFinite(raw)?Math.trunc(raw):1));
      const base=Number(variant.price)||0;
      const discountFor = q => q>=3?15:q>=2?10:0;
      const compute = q => Math.round(base*q*(100-discountFor(q))/100);
      all("[data-bundle-price]").forEach(el=>{ el.textContent=money(compute(Number(el.dataset.bundlePrice))); });
      all("[data-bundle-qty]").forEach(btn=>{
        const active=n===Number(btn.dataset.bundleQty);
        btn.classList.toggle("is-selected",active);
        btn.setAttribute("aria-pressed",String(active));
      });
      const unavailable = find("[data-add-to-cart]")?.disabled || find("[data-variant-error]")?.hidden===false;
      if(count) count.textContent=String(n);
      if(unavailable) {
        if(total) total.textContent="—";
        if(before) before.hidden=true;
        if(saving) saving.hidden=true;
        if(label) label.textContent="יש לבחור אפשרות זמינה";
        return;
      }
      const subtotal=base*n;
      const due=compute(n);
      const percentage=discountFor(n);
      if(total) total.textContent=money(due);
      if(before) { before.hidden=!percentage; before.textContent=percentage?money(subtotal):""; }
      if(saving) { saving.hidden=!percentage; saving.textContent=percentage?"חיסכון "+money(subtotal-due):""; }
      if(label) label.textContent=percentage?percentage+"% הנחה צפויה":"מחיר לפני משלוח";
    };
    root.addEventListener("click",event=>{
      if(event.target.closest("[data-bundle-qty],[data-quantity-plus],[data-quantity-minus],[data-option-button]"))render();
    });
    qty.addEventListener("input",render);
    qty.addEventListener("change",()=>{
      qty.value=String(Math.max(1,Math.min(99,Math.trunc(Number(qty.value)||1))));
      render();
    });
    render();
  });
})();